import { AppRouter, RouterOutput } from '@gongsegae/api';
import { QueryClient } from '@tanstack/react-query';
import { createTRPCClient, httpLink } from '@trpc/client';
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpLink({
      url: import.meta.env.VITE_TRPC_URL,
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});

export type MenuById = RouterOutput['menu']['byId'];
export type MenuGrouped = RouterOutput['menu']['grouped'];
export type StockRemainingByDate = RouterOutput['stock']['getRemainingByDate'];
